const AccountSettingTitle = {
  EMAIL: 'email',
  PUSH: 'push',
  ECG: 'ecg',
} as const;

type AccountSettingTitle = typeof AccountSettingTitle[keyof typeof AccountSettingTitle];

export { AccountSettingTitle };
